module.exports = __webpack_public_path__ + "img/logo.34d1e154.png";